<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <section class="section is-main-section">
      <card-component
        :title="formCardTitle"
        icon="file-edit"
        class="tile is-child"
      >
        <volunteer-add
          @handleAddVolunteer="handleAddVolunteer"
          @handleEditVolunteer="handleEditVolunteer"
        />
      </card-component>
    </section>
  </div>
</template>

<script>
import TitleBar from "../components/TitleBar.vue";
import CardComponent from "@/components/CardComponent";
import { pathOr } from "ramda";
import VolunteerAdd from "../components/volunteering/volunteers/volunteer-add.vue";
import Volunteering from "../services/volunteering.service";
import { notify } from "@/helpers/notify";

export default {
  components: { TitleBar, VolunteerAdd, CardComponent },
  name: "Volunteer",
  data() {
    return {
      volunteer: {},
      volunteerId: 0,
      editMode: false,
    };
  },
  computed: {
    titleStack() {
      const parent = { label: "Registru Voluntariat", to: "/Volunteering" };
      if (this.editMode) {
        return [parent, "Editare"];
      } else {
        return [parent, "Adaugare voluntar"];
      }
    },
    formCardTitle() {
      if (this.editMode) {
        return "Editare";
      } else {
        return "Adaugare voluntar";
      }
    },
  },
  methods: {
    async handleAddVolunteer(volunteer) {
      try {
        const { addVolunteer } = Volunteering;
        const response = await addVolunteer(volunteer);
        const { data, status } = response;
        if (status == "200") {
          notify.success(this, "Inregistrarea a fost adaugata.");
          this.$router.push({ path: `/Volunteering` });
        } else {
          notify.error(this, "Eroare la adaugarea inregistrarii.");
        }
      } catch (error) {
        notify.error(this);
      }
    },
    async handleEditVolunteer(volunteer) {
      try {
        const { editVolunteer } = Volunteering;
        const response = await editVolunteer(volunteer);
        const { data, status } = response;
        if (status == "200") {
          notify.success(this, "Inregistrarea a fost modificata.");
          this.$router.push({ path: "/Volunteering" });
        } else {
          notify.error(this, "Eroare la modificarea inregistrarii.");
        }
      } catch (error) {
        notify.error(this);
      }
    },
  },
  created() {
    const id = parseInt(pathOr(null, ["params", "id"], this?.$route));
    if (id) {
      this.editMode = true;
    }
    this.volunteerId = id;
  },
};
</script>

<style></style>
